
export class TabModel<T> {
    key: T | undefined;
    label: string  = '';
    visible = true;

    constructor(init?: Partial<TabModel<T>>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}